import { Mesh } from '@babylonjs/core/Meshes/mesh';
export const checkMesh = (value) => {
    if (!(value instanceof Mesh)) {
        throw new Error(`Expected Mesh, but received ${String(value)}`);
    }
    return value;
};
